import React from "react";
import "react-chatbot-kit/build/main.css";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Home from './pages/Home';
import Chat from './pages/Chat';
import Indentity from "./pages/Indentity";
import ChartTest from './components/ChartTest';
function App() {
  const navigate = useNavigate();

  const handleFileUpload = (params) => {
    // navigate('/chat?user_id=' + encodeURI(params.userId) + '&company_name=' + encodeURI(params.companyName) || ' ');
    navigate(`identity?user_id=${encodeURI(params.userId)}`)
  };

  return (
    <Routes>
      <Route path="/" element={<Home onUploadSuccess={handleFileUpload} />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/identity" element={<Indentity/>}/>
      <Route path="/chart-test" element={<ChartTest/>}/>
    </Routes>
  );
}

// Wrapper component to provide router context
function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
